import React from 'react';

function TransactionLine({transaction}) {
    // Function to determine status badge styling
    const getStatusBadgeClass = (status) => {
        status = status?.toLowerCase() || '';

        if (status.includes('success') || status.includes('approved') || status.includes('completed')) {
            return 'bg-green-50 text-green-600 border border-green-100';
        } else if (status.includes('pending') || status.includes('processing')) {
            return 'bg-orange-50 text-orange-600 border border-orange-100';
        } else if (status.includes('fail') || status.includes('error') || status.includes('declined')) {
            return 'bg-rose-50 text-rose-600 border border-rose-100';
        } else if (status.includes('refund')) {
            return 'bg-teal-50 text-teal-600 border border-teal-100';
        } else {
            return 'bg-gray-50 text-gray-600 border border-gray-100';
        }
    };

    // Format date if available
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return dateString;
        }
    };

    return (
        <tr className="hover:bg-gray-50 transition-colors duration-150 group">
            <td className="whitespace-nowrap px-4 py-4 first:pl-8 text-sm font-bold text-gray-900">{transaction?.merchantReference ?? '-'}</td>
            <td className="whitespace-nowrap px-4 py-4 text-xs font-mono text-gray-500 max-w-[150px] truncate" title={transaction?.transactionId ?? ''}>{transaction?.transactionId ?? '-'}</td>
            <td className="whitespace-nowrap px-4 py-4 text-xs font-mono text-gray-500">{transaction?.authCode ?? '-'}</td>
            <td className="whitespace-nowrap px-4 py-4 text-xs font-mono text-gray-500">{transaction?.cardNumber ?? '-'}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase ${getStatusBadgeClass(transaction?.status)}`}>
                    {transaction?.status ?? 'Unknown'}
                </span>
            </td>
            <td className="px-4 py-4 text-xs text-gray-500 max-w-[200px]">
                <div className="line-clamp-1 group-hover:line-clamp-none transition-all">{transaction?.description ?? '-'}</div>
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-xs font-medium text-gray-500">{formatDate(transaction?.createdAt)}</td>
        </tr>
    );
}

export default TransactionLine;
